import {
  SingleSelectionConfigurator,
  MultipleSelectionConfigurator,
  CommentConfigurator,
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const escWebuiUserCancelSignupSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'EscWebuiUserCancelSignupSurvey',
    style: {
      root: {
        minHeight: 420,
        '@media (min-width: 600px)': {
          minWidth: 600,
          minHeight: 320,
        },
      },
    },
    others: {
      isGlobalModalStyleEnabled: true,
      isThankYouPageEnabled: false,
      isUserInitiatedSurvey: true,
      combineTextInputToComment: true,
      isInPageMiddle: true,
    },
    questions: [
      {
        isRequired: false,
        Type: SingleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Please let us know why you decided not to sign up')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('I don\'t know what I\'m signing up for')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('The sign up process is too long and/or confusing')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('I don\'t want to share my business details too soon')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('The product doesn\'t provide what I need for my business')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('I plan to sign up later')),
          },
          {
            key: 'q1o6',
            text: i18n.getString(_TL_('The coupon I used isn\'t being applied')),
          },
          {
            key: 'q1o7',
            hasInput: true,
            text: 'Other',
          },
        ],
        data: {
        },
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q2',
        page: 1,
        position: 0,
        getTitle: () => i18n.getString(_TL_('What in the setup process is confusing? Choose all that apply:')),
        isVisible: answers => answers.q1.selectedOption === 'q1o2',
        options: [
          {
            key: 'q2o1',
            text: i18n.getString(_TL_('I don\'t understand why I need so many steps')),
          },
          {
            key: 'q2o2',
            text: i18n.getString(_TL_('I need more help to understand the sign up process')),
          },
          {
            key: 'q2o3',
            text: i18n.getString(_TL_('The UI is very complicated')),
          },
          {
            key: 'q2o4',
            text: i18n.getString(_TL_('Account creation is very complicated')),
          },
          {
            key: 'q2o5',
            text: i18n.getString(_TL_('Campaign creation process is tedious')),
          },
          {
            key: 'q2o6',
            hasInput: true,
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        data: {
        },
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q3',
        page: 1,
        position: 1,
        getTitle: () => i18n.getString(_TL_('Can you elaborate more why the product doesn\'t meet your business expectations?')),
        placeholder: i18n.getString(_TL_('Please don\'t include any confidential or personal information.')),
        isVisible: answers => answers.q1.selectedOption === 'q1o4',
      },
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q4',
        page: 1,
        position: 2,
        getTitle: () => i18n.getString(_TL_('Reasons to sign up later')),
        isVisible: answers => answers.q1.selectedOption === 'q1o5',
        options: [
          {
            key: 'q4o1',
            text: i18n.getString(_TL_('Would like more time to think about it')),
          },
          {
            key: 'q4o2',
            text: i18n.getString(_TL_('My agent will finish up the process for me')),
          },
          {
            key: 'q4o3',
            text: i18n.getString(_TL_('Not sure if I am ready to start a campaign yet')),
          },
          {
            key: 'q4o4',
            text: i18n.getString(_TL_('Don\'t have the budget to run a campaign now')),
          },
          {
            key: 'q4o5',
            text: i18n.getString(_TL_('Don\'t understand the benefits of signing up if not ready to run a campaign')),
          },
          {
            key: 'q4o6',
            hasInput: true,
            placeholder: i18n.getString(_TL_('Other')),
          },
        ],
        data: {
        },
      },
      {
        isRequired: false,
        Type: CommentConfigurator,
        key: 'q5',
        page: 1,
        position: 3,
        getTitle: () => i18n.getString(_TL_('Do you have any other feedback you\'d like to give us about Microsoft Advertising?')),
        placeholder: i18n.getString(_TL_('Please don\'t include any confidential or personal information.')),
        isVisible: () => true,
      },
    ],
  };
};
